import { render } from "./ProductosIndex.vue?vue&type=template&id=7695f244"
import script from "./ProductosIndex.vue?vue&type=script&lang=js"
export * from "./ProductosIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/cruds/ProductosIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7695f244"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7695f244', __exports__)) {
    api.reload('7695f244', __exports__)
  }
  
  module.hot.accept("./ProductosIndex.vue?vue&type=template&id=7695f244", () => {
    api.rerender('7695f244', render)
  })

}


export default __exports__